class Parceiro {
  id: Number = 0;
  "apelido": String = "";
  "nome": String = "";
  "contato": String = "";
  "enderecoExterior": boolean = false;
  "endereco": String = "";
  "enderecoComplemento": String = "";
  "bairro": String = "";
  "cidade": String = "";
  "uf": String = "";
  "cep": String = "";
  "pais": String = "";
  "email": String = "";
  "telefone": String = "";
  "telefoneContato": String = "";
  "site": String = "";
  "codigoFornecedorSAP": Number = 0;
  "codigoClienteSAP": Number = 0;
  "codigoCentroEspelho": Number = 0;
  "criadoEm": Date = new Date();
  "excluidoEm": Date = new Date();
  "d_E_L_E_T_E": boolean = false;
  "grupo": String = "";
}
export default Parceiro;
